import { isMobile } from "react-device-detect";
import MobileRoutes from "./MobileRoutes";
import PCRoutes from "./PCRoutes";

export default isMobile ? MobileRoutes : PCRoutes